<template>
  <div class="p-contact">
    <section class="c-p-r about-banner">
      <div class="c-d-f c-fd-c c-ai-c c-ta-c cm-width about-banner-desc">
        <p class="c-fs-38 c-mb-32 c-fw-b top-title">联系我们</p>
        <!-- <p class="c-fs-16 c-ff-l top-desc">报道企业最新消息，实时发布企业动向</p> -->
      </div>
    </section>
    <div class="cm-width contact-wrap">
      <div class="c-visible-pc" v-if="$store.state.isPc">
        <div class="c-d-f c-ai-c c-jc-c c-mt-80 c-fs-24">
          <img src="../assets/index/icon.png">
          <span class="c-ml c-mr c-c-text-blue">公司介绍</span>
          <img src="../assets/index/icon.png">
        </div>
        <div class="c-mt-52 intro-wrap">
          <img src="../assets/contact/address1.jpg" class="intro-item-img"/>
          <div class="c-lh-38 c-c-text-grey intro-item-text">
            <div class="c-d-f c-ai-c">
              <p class="c-fs-20 c-mb-8 c-c-text-color">安徽高颐科技有限公司</p>
            </div>
            <p>地址：安徽省池州经济技术开发区电子信息产业园7楼</p>
            <p>电话：4006-111-696</p>
            <p>联系人：joshua</p>
            <p>邮编：247100</p>
            <p>邮箱：joshua#quaee.com</p>
          </div>
        </div>
      </div>
      <div class="c-visible-mobile" v-if="!$store.state.isPc">
        <div class="c-d-f c-ai-c c-jc-c c-mt-40">
          <img class="c-icon-mobile" src="../assets/index/icon.png">
          <span class="c-ml-8 c-mr-8 c-fs-19 c-c-text-blue">公司介绍</span>
          <img class="c-icon-mobile" src="../assets/index/icon.png">
        </div>
        <div class="c-d-f c-ai-c c-mt-24 c-mb-8">
          <p class="c-fs-15">安徽高颐科技有限公司</p>
        </div>
        <div class="c-mb-20 c-fs-12 c-lh-22 c-c-text-grey">
          <p>地址：安徽省池州经济技术开发区电子信息产业园7楼</p>
          <p>电话：4006-111-696</p>
          <p>联系人：joshua</p>
          <p>邮编：247100</p>
          <p>邮箱：joshua#quaee.com</p>
        </div>
        <img src="../assets/contact/address1.jpg" style="width: 100%;">
      </div>
      <div class="c-visible-pc" v-if="$store.state.isPc">
        <div class="c-mt-80 c-pb-164 address-list">
          <div class="c-d-f c-ai-c c-jc-c c-mt-80 c-mb-52 c-fs-24">
            <img src="../assets/index/icon.png">
            <span class="c-ml c-mr c-c-text-blue">分支机构</span>
            <img src="../assets/index/icon.png">
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-c-text-grey">
            <div class="address-item">
              <p class="c-fs-20 c-mb-24 c-c-text-color">安徽 (总部)</p>
              <p class="c-mb-16">4006-111-696</p>
              <p>ah#quaee.com</p>
            </div>
            <div class="address-item">
              <p class="c-fs-20 c-mb-24 c-c-text-color">上海 (研发中心)</p>
              <p class="c-mb-16">4006-111-696</p>
              <p>sh#quaee.com</p>
            </div>
            <div class="address-item">
              <p class="c-fs-20 c-mb-24 c-c-text-color">广州 (运营中心)</p>
              <p class="c-mb-16">4006-111-696</p>
              <p>gz#quaee.com</p>
            </div>
            <div class="address-item">
              <p class="c-fs-20 c-mb-24 c-c-text-color">北京 (运营中心)</p>
              <p class="c-mb-16">4006-111-696</p>
              <p>bj#quaee.com</p>
            </div>
            <div class="address-item">
              <p class="c-fs-20 c-mb-24 c-c-text-color">成都 (运营中心)</p>
              <p class="c-mb-16">4006-111-696</p>
              <p>cd#quaee.com</p>
            </div>
            <div class="address-item">
              <p class="c-fs-20 c-mb-24 c-c-text-color">海南 (研发中心)</p>
              <p class="c-mb-16">4006-111-696</p>
              <p>hn#quaee.com</p>
            </div>
          </div>
        </div>
      </div>
      <div class="c-visible-mobile" v-if="!$store.state.isPc">
        <div class="c-mt-40 c-pb-16 address-list-mobile">
          <div class="c-d-f c-ai-c c-jc-c c-mt-40">
            <img class="c-icon-mobile" src="../assets/index/icon.png">
            <span class="c-ml-8 c-mr-8 c-fs-19 c-c-text-blue">分支机构</span>
            <img class="c-icon-mobile" src="../assets/index/icon.png">
          </div>
          <div class="c-fs-12 c-c-text-grey">
            <div class="address-item">
              <p class="c-fs-15 c-mb-24 c-c-text-color">安徽 (总部)</p>
              <p class="c-mb-12">4006-111-696</p>
              <p class="c-mb-12">ah#quaee.com</p>
            </div>
            <div class="address-item">
              <p class="c-fs-15 c-mb-24 c-c-text-color">上海 (研发中心)</p>
              <p class="c-mb-12">4006-111-696</p>
              <p class="c-mb-12">sh#quaee.com</p>
            </div>
            <div class="address-item">
              <p class="c-fs-15 c-mb-24 c-c-text-color">广州 (运营中心)</p>
              <p class="c-mb-12">4006-111-696</p>
              <p class="c-mb-12">gz#quaee.com</p>
            </div>
            <div class="address-item">
              <p class="c-fs-15 c-mb-24 c-c-text-color">北京 (运营中心)</p>
              <p class="c-mb-12">4006-111-696</p>
              <p class="c-mb-12">bj#quaee.com</p>
            </div>
            <div class="address-item">
              <p class="c-fs-15 c-mb-24 c-c-text-color">成都 (运营中心)</p>
              <p class="c-mb-12">4006-111-696</p>
              <p class="c-mb-12">cd#quaee.com</p>
            </div>
            <div class="address-item">
              <p class="c-fs-15 c-mb-24 c-c-text-color">海南 (研发中心)</p>
              <p class="c-mb-12">4006-111-696</p>
              <p class="c-mb-12">hn#quaee.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'resolution',
  data () {
    return {
    }
  },
  methods: {
    toUrl (url) {
      if (url) {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style lang="scss">
.p-contact {
  min-height: calc(100vh - 90px - 525px);
  .about-banner {
    height: 560px;
    background: url("../assets/training/training-top.jpg") no-repeat;
    background-size: cover;
    background-position: center;
    @media screen and (max-width: $max-width-standard) {
      height: 232px;
      background: url("../assets/training/training-top-m.jpg") no-repeat;
      background-size: cover;
      background-position: center;
      .top-title {
        font-size: 19px;
        margin-bottom: 12px;
      }
      .top-desc {
        width: 70%;
        font-size: 9px;
        line-height: 16px;
        margin-bottom: 15px!important;
      }
    }
    .about-banner-desc {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .contact-wrap {
    .intro-wrap {
      display: flex;
      justify-content: space-between;
      .intro-item-text {
        width: 46%;
      }
      .intro-item-img {
        width: 46%;
        height: 340px;
        object-fit: cover;
      }
    }
    .address-list {
      .address-item {
        width: 30%;
        margin-bottom: 32px;
        padding: 40px 30px;
        border-radius: 20px;
        text-align: center;
        background: white;
        box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
      }
    }
    .address-list-mobile {
      .address-item {
        width: 80%;
        margin: 24px auto;
        padding: 40px 30px;
        border-radius: 20px;
        text-align: center;
        background: white;
        box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
      }
    }
  }
}
</style>
